<template>
  <div>
    <Top :username="username" />
    <div class="content-wrapper back">
      <div class="container">
        <section class="content-header">
          <div class="row">
            <img
              src="assets/images/ug1.jpg"
              alt
              style="display:block;margin:auto"
              class="img img-responsive"
            />
            <h3
              style="text-align:center;font-weight:bold"
            >SCHOOL OF PUBLIC HEALTH, UNIVERSITY OF GHANA</h3>
            <h4
              style="text-align:center;font-weight:bold"
            >DASH Masters and PhD Fellowships in Adolescent Health - {{ academic_year }} Academic Year</h4>
          </div>
        </section>

        <section class="content" style="margin-bottom:20px">
          <div class="box card-2">
            <div class="box-header">
              <h3 class="box-title">APPLICATION SUMMARY</h3>
            </div>
            <div class="box-body" style="padding:2rem 2rem">
              <h3 style="text-align:center">SUMMARY OF YOUR APPLICATION</h3>
              <img
			  	ref="myimage"
                src="assets/images/profile.png"
                alt="Avatar"
                style="max-width:200px;display:block;margin:auto"
              />
              <br />
              <br />
              <h4 style="text-align:center">PERSONAL PROFILE</h4>
              <table class="table">
                <tbody>
					<tr>
                    <th class="trows">PROGRAM APPLIED FOR</th>
                    <td>{{formdata.program_applied.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">TITLE</th>
                    <td>{{formdata.title.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">SURNAME</th>
                    <td>{{formdata.surname.toUpperCase()}}</td>
                  </tr>
				 
                  <tr>
                    <th class="trows">OTHERNAMES</th>
                    <td>{{formdata.othernames.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">GENDER</th>
                    <td>{{formdata.gender.toUpperCase()}}</td>
                  </tr>
				  <tr>
                    <th class="trows">DATE OF BIRTH</th>
                    <td>{{formdata.dob.toUpperCase()}}</td>
                  </tr>
				  <tr>
                    <th class="trows">PLACE OF BIRTH</th>
                    <td>{{formdata.place_birth.toUpperCase()}}</td>
                  </tr>
                  <!-- <tr>
                    <th class="trows">COUNTRY OF CITIZENSHIP</th>
                    <td>{{formdata.nationality.toUpperCase()}}</td>
                  </tr> -->
                  <tr>
                    <th class="trows">MOBILE PHONE NUMBER</th>
                    <td>{{formdata.phone.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">EMAIL</th>
                    <td>{{formdata.email.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">POSTAL ADDRESS</th>
                    <td>{{formdata.address.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">CURRENTLY EMPLOYED</th>
                    <td>{{formdata.isemployed.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">POSITION</th>
                    <td>{{formdata.position.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">NAME OF INSTITUTION</th>
                    <td>{{formdata.employername.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">INSTITUTION EMAIL ADDRESS</th>
                    <td>{{formdata.employeremail.toUpperCase()}}</td>
                  </tr>
                  <tr>
                    <th class="trows">INSTITUTION POSTAL ADDRESS</th>
                    <td>{{formdata.employeraddress.toUpperCase()}}</td>
                  </tr>
                </tbody>
              </table>

              <h4 style="text-align:center;margin-top:20px">EDUCATIONAL INFORMATION</h4>
              <table class="table">
                <thead>
                  <tr>
                    <th>Dates</th>
                    <th>Institution Attended</th>
                    <th>Major Subjects</th>
                    <th>Degree Completed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="eduhistory.length===0">
                    <td colspan="4" style="text-align:center">No Records Added</td>
                  </tr>
                  <tr v-else v-for="(e,index) in eduhistory" :key="index">
                    <td>{{e.startDate | moment}} -- {{e.endDate | moment}}</td>
                    <td>{{e.institution}}</td>
                    <td>{{e.subjects}}</td>
                    <td>{{e.degree}}</td>
                  </tr>
                </tbody>
              </table>

              <h4 style="text-align:center;margin-top:20px">EMPLOYMENT INFORMATION</h4>
              <table class="table">
                <thead>
                  <tr>
                    <th>Dates</th>
                    <th>Position / Title</th>
                    <th>Employer</th>
                    <th>City/Country</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="emphistory.length===0">
                    <td colspan="4" style="text-align:center">No Records Added</td>
                  </tr>
                  <tr v-else v-for="(d,index) in emphistory" :key="index">
                    <td>{{d.startDate | moment}} -- {{d.endDate | moment}}</td>
                    <td>{{d.position}}</td>
                    <td>{{d.employer}}</td>
                    <td>{{d.country}}</td>
                  </tr>
                </tbody>
              </table>
              <br />
              <br />

			  <h4 style="text-align:center;margin-top:20px">DOCUMENTS UPLOADED</h4>
              <table class="table">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Name of File</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
					  <td>A cover letter explaining your interest in the project.</td>
					  <td><a target="_blank" :href="'https://sts.ug.edu.gh/itsev8engine/public/chsdash/docs/'+docs['coverletter']['name']">{{docs['coverletter']['name']}}</a></td>
					  <td>
						  <span v-if="docs['coverletter']['hasuploaded']" class="label label-success">Uploaded</span>
						  <span v-else class="label label-danger">Not Uploaded</span>
					  </td>
				  </tr>
				  <tr>
					  <td>Complete curriculum vitae (CV), including statistical analysis and research experience.</td>
					  <td><a target="_blank" :href="'https://sts.ug.edu.gh/itsev8engine/public/chsdash/docs/'+docs['cv']['name']">{{docs['cv']['name']}}</a></td>
					  <td>
						  <span v-if="docs['cv']['hasuploaded']" class="label label-success">Uploaded</span>
						  <span v-else class="label label-danger">Not Uploaded</span>
					  </td>
				  </tr>
				  <tr>
					  <td>Personal Statement.</td>
					  <td><a target="_blank" :href="'https://sts.ug.edu.gh/itsev8engine/public/chsdash/docs/'+docs['essay']['name']">{{docs['essay']['name']}}</a></td>
					  <td>
						  <span v-if="docs['essay']['hasuploaded']" class="label label-success">Uploaded</span>
						  <span v-else class="label label-danger">Not Uploaded</span>
					  </td>
				  </tr>
				  <tr>
					  <td>Proof of application to the University of Ghana.</td>
					  <td><a target="_blank" :href="'https://sts.ug.edu.gh/itsev8engine/public/chsdash/docs/'+docs['admissionletter']['name']" >{{docs['admissionletter']['name']}}</a></td>
					  <td>
						  <span v-if="docs['admissionletter']['hasuploaded']" class="label label-success">Uploaded</span>
						  <span v-else class="label label-danger">Not Uploaded</span>
					  </td>
				  </tr>
				  <tr>
					  <td>At least one (1) letter of recommendation</td>
					  <td><a target="_blank" :href="'https://sts.ug.edu.gh/itsev8engine/public/chsdash/docs/'+docs['recommendation']['name']">{{docs['recommendation']['name']}}</a></td>
					  <td>
						  <span v-if="docs['recommendation']['hasuploaded']" class="label label-success">Uploaded</span>
						  <span v-else class="label label-danger">Not Uploaded</span>
					  </td>
				  </tr>
                </tbody>
              </table>
			  <br>
			  <br>
              <div class="row text-center" style="justify-content:center;">
                <router-link to="/apply" class="btn btn-primary">BACK TO FORM</router-link>&nbsp;&nbsp;
                <button class="btn btn-success" @click="acceptAndSubmit">ACCEPT AND SUBMIT</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Top from "./partials/Top.vue";
import Footer from "./partials/Footer.vue";
import moment from 'moment'
export default {
  name: "Summary",
  components: {
    Top,
    Footer
  },
  data() {
    return {
      username: "",
      eduhistory: [],
	  emphistory: [],
	  academic_year:"2024/2025",
	  docs: {
        coverletter: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        },
        cv: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        },
        essay: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        },
		admissionletter: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        },
        recommendation: {
          file: "",
          text: "Upload",
          selected: false,
          name: "",
          size: "",
          hasuploaded: false
        }
      },
      formdata: {
        id: "",
        title: "",
        surname: "",
        othernames: "",
        gender: "",
        nationality: "",
        email: "",
        phone: "",
		program_applied:"",
		place_birth:'',
		dob:'',
		aca_bkground:'',
        address: "",
        isemployed: "",
        position: "",
        employername: "",
        employeremail: "",
        employeraddress: "",
        image: ""
      }
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM Do YYYY');
    }
  },
  methods: {

	  
    fetchEduHistory() {
      this.$http
        .get(this.appenv.baseurl + "/fetchemphistory?id=" + this.formdata.id)
        .then(res => {
          if (res.data) {
            this.emphistory = res.data.emphistory;
			if(res.data.academic_year){
			this.academic_year = res.data.academic_year
		  }
          }
        })
        .catch();
	},
	acceptAndSubmit(){
		this.$http
        .get(this.appenv.baseurl + "/accept?id=" + this.formdata.id)
        .then(res => {
          if (res.data && res.data.status==='success') {
            this.$swal('Success','Your Application has been submitted succesfully','success')
          }else{
			  this.$swal('Info',res.data.message,'info')
		  }
        })
        .catch();
	},
	fetchDocs(){
		let _this = this;
		this.$http
        .get(this.appenv.baseurl + "/fetchdocs?id="+this.formdata.id)
        .then(res => {
		  let docs = res.data.docs;
		  for(var i=0;i<docs.length;i++){
			  switch(docs[i]['type']){
				  case 'coverletter':
					  //	_this.docs[type]["file"] = file;
						_this.docs['coverletter']["selected"] = true;
						_this.docs['coverletter']["name"] = docs[i]['name'];
						_this.docs['coverletter']["size"] = 0;
						_this.docs['coverletter']["hasuploaded"] = true;
				  break;
				  case 'cv':
					  	_this.docs['cv']["selected"] = true;
						_this.docs['cv']["name"] = docs[i]['name'];
						_this.docs['cv']["size"] = 0;
						_this.docs['cv']["hasuploaded"] = true;
				  break;
				  case 'admissionletter':
					  	_this.docs['admissionletter']["selected"] = true;
						_this.docs['admissionletter']["name"] = docs[i]['name'];
						_this.docs['admissionletter']["size"] = 0;
						_this.docs['admissionletter']["hasuploaded"] = true;
				  break;
				  case 'essay':
					  	_this.docs['essay']["selected"] = true;
						_this.docs['essay']["name"] = docs[i]['name'];
						_this.docs['essay']["size"] = 0;
						_this.docs['essay']["hasuploaded"] = true;
				  break;
				  case 'recommendation':
					  _this.docs['recommendation']["selected"] = true;
						_this.docs['recommendation']["name"] = docs[i]['name'];
						_this.docs['recommendation']["size"] = 0;
						_this.docs['recommendation']["hasuploaded"] = true;
				  break;
				  default:
				  break;
			  }
		  }
        })
        .catch();
	},
    fetchEmpHistory() {
      this.$http
        .get(this.appenv.baseurl + "/fetchedubackground?id=" + this.formdata.id)
        .then(res => {
          if (res.data) {
			this.eduhistory = res.data.eduhistory;
			
          }
        })
        .catch();
    },
    pickBiodata() {
      let me = this;
      this.$http
        .get(this.appenv.baseurl + "/fetchprofile?id=" + this.formdata.id)
        .then(res => {
		  let user = res.data.user;
		  if(res.data.academic_year){
			this.academic_year = res.data.academic_year
		  }
          Object.keys(user).forEach(function(item) {
            me.formdata[item] = user[item] === null ? "" : user[item];
		  });
		  //console.log(me.formdata);
		  if(!(me.formdata.image===null  || me.formdata.image==='')){ 
			  this.$refs.myimage.src = me.formdata.image;
		  }
        })
        .catch();
    }
  },
  mounted: function() {
    if (localStorage.getItem("user") && localStorage.getItem("apikey")) {
      //console.log(localStorage.getItem('user')===null);
      if (
        localStorage.getItem("user") === "undefined" ||
        localStorage.getItem("user") === null
      ) {
        localStorage.removeItem("apikey");
        localStorage.removeItem("user");
        this.$router.push("login");
      } else {
        var user = JSON.parse(localStorage.getItem("user"));
        var me = this;
        Object.keys(user).forEach(function(item) {
          me.formdata[item] = user[item] === null ? "" : user[item];
        });

        this.username = me.formdata.surname;
        this.fetchEduHistory();
		this.fetchEmpHistory();
		this.pickBiodata();
		this.fetchDocs();
        //console.log(me.formdata.academicproof);
      }
    } else {
      localStorage.removeItem("apikey");
      localStorage.removeItem("user");
      this.$router.push("login");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.trows {
  text-align: right;
  width: 50%;
}
</style>
